import styled from 'styled-components';
import { Icon } from '../ui';

export const ListingRatingWrapper = styled.div`
  position: absolute;
  top: 50%;
  right: 0;
  transform: translateY(-50%);
`;

export const StarWrapper = styled.div`
  position: relative;
  height: 16px;
`;

export const FilledStarWrapper = styled.div`
  position: absolute;
  left: 0;
  top: 0;
  width: ${({ width }) => `${width}%`};
  overflow: hidden;
`;

export const RatingWrapper = styled.div`
  font-size: 1.125rem;
  font-weight: 700;
  line-height: 1;
`;

export const SkeletonStar = styled(Icon)``;

export const FilledStar = styled(Icon)`
  color: ${({ theme }) => theme.COLOR_AMBER_ORANGE};
`;

export const ListingRatingContainer = styled.div`
  display: flex;
  gap: 0.25rem;
  align-items: flex-start;
`;
